<template>
  <ap-dialog
    :mask="true"
    v-model="dialogVisible"
    customClass="product-detail"
    title="Product Detail"
    position="0"
    style="--ap-dialog-width:800px; --ap-dialog-padding-primary:10px;">
    <product-detail
      :productDetailPopupInfo="productDetailPopupInfo"
      :imageSwiperBig="imageSwiperBig">
    </product-detail>
    <template #footer>
      <div class="product-detail-popup-btn">
          <ap-button
            type="button"
            class="product-detail-popup-btn-gray"
            @click="backToProductPage"
            >Back to Product Page</ap-button
          >
          <ap-button
            type="button"
            class="product-detail-popup-btn-org"
            v-show="isShowEditDetails"
            @click="backToEditProductDetailsPage"
            >Edit Details</ap-button
          >
          <ap-button
            type="button"
            class="product-detail-popup-btn-org"
            v-show="!isShowEditDetails"
            @click="closeMe"
            >Close</ap-button
          >
      </div>
    </template>
  </ap-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { GetProductDetailPopupInfo } from '@anypromo/shared/api/ProductClient'

import ProductDetail from './ProductDetail.vue'

import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.min.css'

import ApEvent from '@anypromo/shared/utils/ApEvent'
import { ApButton, ApDialog } from '@anypromo/components-pc'
import type { ProductDetailPopupInfo } from '@anypromo/shared/types/Product'

export default defineComponent({
  name: 'ProductDetailPc',
  components: {  ProductDetail, ApButton ,ApDialog},
  emits: ['go-next', 'go-back'],
  data() {
    return {
      productID: 0,
      defaultImageUrl: '',
      isShowEditDetails: false,
      sessionGuid: '',
      dialogVisible: false,
      productLink: '',
      productDetailPopupInfo: {} as ProductDetailPopupInfo,
      imageSwiperBig: {} as Swiper
    }
  },
  computed: {},
  created() {
    ApEvent.on(
      'ShowProductDetailPopup',
      (
        productID: number,
        defaultImageUrl: string,
        isShowEditDetails: boolean,
        sessionGuid: string
      ) => {
        this.InitPage(
          productID,
          defaultImageUrl,
          isShowEditDetails,
          sessionGuid
        )
      }
    )
  },
  watch: {
    productID(newVal: number, oldVal: number) {
      if (newVal !== oldVal) {
        this.productDetailPopupInfo = {} as ProductDetailPopupInfo
      }
    }
  },
  methods: {
    InitPage(
      productID: number,
      defaultImageUrl: string,
      isShowEditDetails: boolean,
      sessionGuid: string
    ) {
      this.productID = productID
      this.defaultImageUrl = defaultImageUrl
      this.isShowEditDetails = isShowEditDetails
      this.sessionGuid = sessionGuid

      GetProductDetailPopupInfo(this.productID, this.defaultImageUrl).then(
        (data) => {
          this.productLink = data.Data.productLink
          this.productDetailPopupInfo = data.Data

          this.dialogVisible = true

          if (this.dialogVisible) {
            this.$nextTick(function () {
              const imageSwiperSmall = new Swiper('.image-swiper-small', {
                spaceBetween: 1,
                slidesPerView: 5,
                watchSlidesVisibility: true,
                watchSlidesProgress: true
              })

              const imageSwiperBig = new Swiper('.image-swiper-big', {
                spaceBetween: 10,
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev'
                },
                thumbs: {
                  swiper: imageSwiperSmall
                }
              })

              imageSwiperBig.slideTo(data.Data.defaultImageIndex)

              this.imageSwiperBig = imageSwiperBig
            })
          }
        }
      )
    },

    backToProductPage() {
      ;(window as any).location.href = this.productLink
    },

    backToEditProductDetailsPage() {
      ;(window as any).location.href =
        'OrderCustomize.aspx?refer=edit&productid=' +
        this.productID +
        '&sessionguid=' +
        this.sessionGuid
    },

    closeMe() {
      this.dialogVisible = false
    },

    showMe(
      productID: number,
      defaultImageUrl: string,
      isShowEditDetails = false,
      sessionGuid = ''
    ) {
      this.InitPage(productID, defaultImageUrl, isShowEditDetails, sessionGuid)
    }
  }
})
</script>

<style scoped>
 :deep(.ap-mobile-close:hover) {
  color: #0e0d0d;
}

h1,
h2 {
  font-weight: normal;
}

:deep(h1),
:deep(h2),
:deep(h3),
:deep(h4),
:deep(h5),
:deep(h6) {
  line-height: 1.1;
  margin-bottom: 10px;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.product-detail-popup-btn {
  text-align: center;
  margin-top: 40px;
  display: block;
}

.product-detail-popup-btn-gray,
.product-detail-popup-btn-org {
  width: 225px;
  height: 45px;
  padding: 0;
  line-height: 45px;
  border-radius: 10px;
  border: 0;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

.product-detail-popup-btn-gray {
  background: #c7c7c7;
}

.product-detail-popup-btn-gray:hover {
  background: #b7b7b7;
}

.product-detail-popup-btn-org {
  background: #ff6600;
  margin-left: 10px;
}

.product-detail-popup-btn-org:hover {
  background: #cd4d08;
}

@media (max-width: 800px) {
  .product-detail-popup-btn {
    margin-top: 20px;
  }
}

@media (max-width: 550px) {
  .product-detail-popup-btn-gray,
  .product-detail-popup-btn-org {
    width: 160px;
    height: 30px;
    line-height: 30px;
    border-radius: 5px;
    font-size: 13px;
    font-weight: 500;
  }
}

@media (max-width: 450px) {
  .product-detail-popup-btn-gray,
  .product-detail-popup-btn-org {
    margin: 10px auto;
    display: block;
  }
}

@media (max-width: 768px) {
  .product-detail :deep(.ap-modal) {
    width: 100%;
    height: calc(100vh);
    overflow: auto;
  }
}
</style>
